<template>
  <div>
    <el-form :model="params" ref="queryForm" :rules="rules">
      <QS-search maxLine="1">
        <el-form-item label="账号ID"  prop="account">
          <el-input
            v-model="params.account"
            placeholder="请输入账号ID"
            v-number:integer="20"
            clearable/>
        </el-form-item>
        <el-form-item label="城市"  prop="city">
          <el-select
            v-model="params.city"
            placeholder="请输入城市"
            filterable
            clearable>
            <el-option
              v-for="item in cityList"
              :key="item.adcode"
              :value="item.adcode"
              :label="item.city">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录方式"  prop="loginMethod">
          <el-select
            v-model="params.loginMethod"
            placeholder="请选择"
            clearable>
            <el-option :value="1" label="账密登录"></el-option>
            <el-option :value="2" label="扫码登录"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否需要U盾"  prop="needUdun">
          <el-select
            v-model="params.needUdun"
            placeholder="请选择"
            clearable>
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="定时查询"  prop="open">
          <el-select
            v-model="params.open"
            placeholder="请选择"
            clearable>
            <el-option value="" label="全部"></el-option>
            <el-option :value="1" label="启用"></el-option>
            <el-option :value="0" label="停用"></el-option>
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="onLoading.search"
              type="primary"
              size="small"
              @click="queryList"
            >
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset"> 重置 </el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <div class="btn-box">
      <el-button
        v-if="judgePermission('vehicle_violation_account_new')"
        type="primary"
        size="small"
        @click="showAddDialog"
      >新建违章查询账号</el-button>
    </div>
    <div class="el-alert-position">
      <el-alert
        title="仅支持对【租赁中状态的个人租赁订单车辆】更新数据"
        type="warning"
        :closable="false"
        show-icon>
      </el-alert>
    </div>
    <QS-common-table
      :loading="onLoading.search"
      :pagination="paginationData"
      :data="tableData"
      :columns="headData"
      @change="paginationChange"
      class="mt16"
    ></QS-common-table>
    <el-dialog
      :visible.sync="dialogInfo.visible"
      :title="dialogInfo.title"
      :width="dialogInfo.type === 'AddAccount' ? '500px' : '650px'"
      :destroy-on-close="true"
      >
      <component
        :is="dialogInfo.type"
        :content="dialogInfo.content"
        :isSave="dialogInfo.isSave"
        :dialogVisible="dialogInfo.visible"
        @saveResult="saveResult"
        @cancelDialog="cancelDialog">
      </component>
      <span v-if="dialogInfo.type !== 'QRCodeLogin'" slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="saveForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import config, { LOGIN_METHOD } from '../config/account'
import AddAccount from './components/addAccount.vue'
import CookieConfig from './components/cookieConfig.vue'
import QRCodeLogin from './components/qrCodeLogin.vue'
// eslint-disable-next-line import/no-cycle
import { getCityList } from '@/api/domain/cars'
import { violationAccountList, updateViolationAccount, queryViolationAccount } from '@/api/domain/carsService'
import { validateAccountNumber } from '@/utils/extendFormVaildate'

export default {
  components: {
    AddAccount,
    CookieConfig,
    QRCodeLogin,
  },
  data() {
    const { headData } = config.call(this)
    return {
      params: {
        account: '',
        city: '',
        needUdun: '',
        open: '',
        loginMethod: '',
      },
      onLoading: {
        search: false,
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      headData,
      tableData: [],
      dialogInfo: {
        visible: false,
        title: '',
        type: '',
        content: null,
        isSave: false,
      },
      cityList: [],
      rules: {
        account: [{ validator: validateAccountNumber, trigger: 'blur' }],
      },
    }
  },
  mounted() {
    this.getCityList()
    this.queryList()
  },
  methods: {
    // 根据输入获取城市列表
    getCityList() {
      getCityList().then(({ code, data }) => {
        if (code === 1) {
          this.cityList = data || []
        }
      })
    },
    queryList() {
      this.$refs.queryForm.validate((valid) => {
        if (!valid) return
        this.onLoading.search = true
        violationAccountList({
          ...this.params,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        }).then(({ code, data }) => {
          if (code === 1) {
            this.tableData = data?.items || []
            this.paginationData.total = data?.totalNum || 0
          }
        }).finally(() => {
          this.onLoading.search = false
        })
      })
    },
    reset() {
      this.$refs.queryForm.resetFields()
      this.paginationData.pageNum = 1
      this.queryList()
    },
    // 编辑单条违查询账号
    // eslint-disable-next-line vue/no-unused-properties
    editAccount(row) {
      this.dialogInfo.visible = true
      this.dialogInfo.title = '编辑违章查询账号'
      this.dialogInfo.type = 'AddAccount'
      this.dialogInfo.content = row
    },
    // 开始查询账号记录
    // eslint-disable-next-line vue/no-unused-properties
    queryAccount(row) {
      if (row.needUdun === 1) {
        // U盾账号
        this.dialogInfo.visible = true
        this.dialogInfo.type = 'CookieConfig'
        this.dialogInfo.title = 'U盾账号查询'
        this.dialogInfo.content = row
        this.dialogInfo.isSave = false
      } else if (row.loginMethod === LOGIN_METHOD.QR_CODE) {
        this.dialogInfo.visible = true
        this.dialogInfo.type = 'QRCodeLogin'
        this.dialogInfo.title = '扫码登录查询'
        this.dialogInfo.content = row
      } else {
        // 非U盾账号
        this.$confirm('确认后立即开始查询，根据车辆数量可能需要半小时左右，请您耐心等待，可通过刷新页面查看查询状态，以确认是否执行完成。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          queryViolationAccount({
            account: row.account,
            id: row.id,
          }).then(({ code }) => {
            if (code === 1) {
              this.queryList()
            }
          })
        }).catch(() => null)
      }
    },
    // 进入到查看记录页面
    // eslint-disable-next-line vue/no-unused-properties
    recordList(row) {
      this.$router.push({
        path: '/vehicle/violation/queryRecord',
        query: {
          account: row.account,
          cityCode: row.cityCode || '',
          id: row.id, // 查询记录时只需要传递id，TODO：未来account和cityCode都去掉，服务的设计有问题，查询记录时直接业务业务字段查询是会随业务变化而改变的
        },
      })
    },
    // 启用/停用账号
    // eslint-disable-next-line vue/no-unused-properties
    changeStatus(row) {
      this.$confirm(`是否${row.open === 1 ? '停用' : '启用'}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        updateViolationAccount({
          id: row.id,
          state: row.open === 1 ? 0 : 1,
        }).then(({ code }) => {
          if (code === 1) {
            this.$message.success(`${row.open === 1 ? '停用' : '启用'}成功`)
            this.queryList()
          }
        })
      }).catch(() => null)
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageNum = pagination.pageNum
      this.paginationData.pageSize = pagination.pageSize
      this.queryList()
    },
    showAddDialog() {
      this.dialogInfo.visible = true
      this.dialogInfo.title = '新建违章查询账号'
      this.dialogInfo.type = 'AddAccount'
      this.dialogInfo.content = null
      this.dialogInfo.isSave = false
    },
    // 新建/编辑账号成功，弹窗关闭，列表刷新
    saveResult(flag) {
      this.dialogInfo.isSave = false
      this.dialogInfo.visible = flag
      !flag && this.queryList()
    },
    cancelDialog(refreshList) {
      this.dialogInfo.visible = false
      this.dialogInfo.isSave = false
      refreshList && this.queryList()
    },
    saveForm() {
      this.dialogInfo.isSave = true
    },
  },
}
</script>
<style lang="less" scoped>
  .el-alert-position {
    margin-top: 10px;
  }
</style>
